<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "appview",
  props: {
    msg: String
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
